import { createRouter, createWebHistory, useLink } from 'vue-router'
import store from '../store'
import Selection from '@/views/Selection.vue'
import Cart from '@/views/Cart.vue'
import Checkout from '@/views/Checkout.vue'
import Login from '@/views/Login.vue'
import NotFound from '@/views/Errors/NotFound.vue'
import ServerError from '@/views/Errors/ServerError.vue'
import Home from '@/views/Home.vue'
import Notice from '@/views/Notice.vue'
import IssuedGiftCard from '@/views/IssuedGiftCard.vue'
import Receipt from '@/views/Receipt.vue'
import Profile from '@/views/Profile.vue'
import Link from '@/views/Link.vue'
import BottleFactory from '@/views/BottleFactory.vue'
import PrivacyPolicy from '@/views/PrivacyPolicy.vue'
import TermsOfService from '@/views/TermsOfService.vue'
import SMSTermsOfService from '@/views/SMSTermsOfService.vue'
import FullPage from '@/views/FullPage.vue'
import config from '@/config'
import { usePosthog } from '@/composables/usePosthog'

const routes = [
  {
    path: '/:pathMatch(.*)',
    component: NotFound
  },
  {
    path: '/500',
    component: ServerError
  },
  {
    path: '/',
    component: Home,
    name: 'Home'
  },
  {
    path: '/:storeSlug?/s/:storeId',
    component: BottleFactory,
    name: 'BottleFactory'
  },
  {
    path: '/login',
    component: Login,
    name: 'NakedLogin'
  },
  {
    path: '/profile',
    component: Profile,
    name: 'Profile'
  },
  {
    path: '/:storeSlug?/b/:bottleid',
    component: Selection,
    name: 'Selection'
  },
  {
    path: '/:storeSlug?/b/:bottleid/cart',
    component: Cart,
    name: 'Cart'
  },
  {
    path: '/:storeSlug?/b/:bottleid/checkout',
    component: Checkout,
    name: 'Checkout'
  },
  {
    path: '/:storeSlug?/b/:bottleid/login',
    component: Login,
    name: 'Login'
  },
  {
    path: '/:storeSlug?/b/:bottleid/notice',
    component: Notice,
    name: 'Notice'
  },
  {
    path: '/:storeSlug?/b/:bottleid/receipt',
    component: Receipt,
    name: 'Receipt'
  },
  {
    path: '/l/:id',
    component: Link,
    name: 'Link'
  },
  {
    path: '/p/:route',
    component: FullPage
  },
  {
    path: '/gc/:code',
    component: IssuedGiftCard,
    name: 'IssuedGiftCard'
  },
  {
    path: '/privacy',
    component: PrivacyPolicy
  },
  {
    path: '/terms-of-service',
    component: TermsOfService
  },
  {
    path: '/sms-terms-of-service',
    component: SMSTermsOfService
  }
]

const router = createRouter({
  history: createWebHistory(config.BASE_URL),
  routes
})

const { posthog } = usePosthog()

router.beforeEach((to, from) => {
  // Ensure token-derived state (including franchiseId) is hydrated on navigation
  if (!store.state.currentTokenMerchant && localStorage.getItem('token')) {
    store.commit('SET_CURRENT_TOKENS', localStorage.getItem('token'))
  }

  if (store.getters.info && store.getters.info.attributes.facebook_pixel_container_id) {
    window.fbq('track', 'PageView', {
      URL: to.fullPath
    })
  }

  const slugAwareRouteNames = ['BottleFactory', 'Selection', 'Cart', 'Checkout', 'Login', 'Notice', 'Receipt']
  const selectedStoreSlug = store.state.selectedStoreSlug
  if (selectedStoreSlug && slugAwareRouteNames.includes(to.name) && !to.params.storeSlug) {
    return {
      name: to.name,
      params: { ...to.params, storeSlug: selectedStoreSlug },
      query: to.query,
      hash: to.hash
    }
  }

  return true
})

export default router
